<template>
  <f7-page name="forgotpassword" class="login BG">
    <f7-row>
      <f7-col width="30"></f7-col>
        <f7-col width="40">
          <div class="app-logo" style="margin-top: 100px">
            <div class="app-logo-dev left-app-logo yellow">AZ</div>
            <div class="app-logo-dev right-app-logo white">
              <span>| CONNECT</span>
            </div>
          </div>
          <!-- User Name -->

          <f7-list no-hairlines-md cl class="login-input">
            <f7-list-item><h2 style="color: #FFF">Forgot Password</h2></f7-list-item>
            <f7-list-input
              outline
              type="email"
              placeholder="Email Address"
              :value="email"
              @input="email = $event.target.value"
            ></f7-list-input>
          </f7-list>



          <div class="action-login">
              <f7-row>
                <f7-col width="80"></f7-col>
                <f7-col width="20">
                  <div class="login-button">
                    <a href="#" @click="forgotPassword">
                        <img src="../assets/images/next.png" />
                      </a>
                  </div>
                </f7-col>
              </f7-row>
          </div>



          <f7-row>
          <f7-col width="15"></f7-col>
          <f7-col width="70">

          </f7-col>
          <f7-col width="15"></f7-col>
          </f7-row>

          <div class="sponser sponser-login">
            <p>Sponsored by</p>
            <div class="sponser-logo">
              <img src="../assets/svg/astra_zeneca_logo-w.svg" />
            </div>
          </div>
        </f7-col>
        <f7-col width="30"></f7-col>
    </f7-row>
  </f7-page>
</template>

<script>
export default {
  data() {
    return {
      email: ''
    }
  },
  methods: {
    forgotPassword: function () {

      if (!this.email) {
        this.$f7.dialog.alert('Please enter your email address')
        return false;
      }

      this.$f7.preloader.show();

      localStorage.setItem('fogotten_mail', this.email)

      this.axios.get( this.$root.apiBaseURL + 'forgot-password?email=' + this.email )
        .then( (response) => {
          this.$f7.preloader.hide()
          this.$f7.dialog.alert( response.data.message, '<span class="color-green">Sent</span>' )
          this.$f7.view.current.router.navigate('/reset-password/')
        })
        .catch( (error) => {
          this.$f7.preloader.hide()
          this.$f7.dialog.alert(error.response.data.error, '<span class="color-red">Error</span>')
        })

    }
  },
  mounted() {
    if (localStorage.getItem('isLoggedIn')) {
      this.$f7.view.current.router.navigate('/', { clearPreviousHistory: true })
    }
  }
}
</script>
